/**
 * SABRILOCKER — Fiche Produit Custom JS
 * Gere : couleur separee, tailles EU/US/UK/CM, prix dynamique,
 *        stock, livraison conditionnelle, galerie, guide tailles, pickup
 */

(function () {
  'use strict';

  var dataEl = document.getElementById('sl-product-data');
  if (!dataEl) return;
  var productData = JSON.parse(dataEl.textContent);
  var variants = productData.variants;
  var threshold = productData.fast_shipping_threshold;
  var moneyFormat = productData.money_format;
  var sizeOptionIndex = productData.size_option_index;
  var colorOptionIndex = productData.color_option_index;

  // State
  var selectedColor = null;
  var selectedSize = null;

  // Init selected color
  var colorBtns = document.querySelectorAll('.sl-colors__btn');
  if (colorBtns.length > 0) {
    var activeColor = document.querySelector('.sl-colors__btn.is-selected');
    if (activeColor) selectedColor = activeColor.dataset.color;
  }

  // Init selected size
  var sizeSelected = document.querySelector('.sl-sizes__btn.is-selected');
  if (sizeSelected) selectedSize = sizeSelected.dataset.size || sizeSelected.dataset.sizeEu;

  // --- Correspondance tailles standard sneakers ---
  var SIZE_MAP = {
    '35.5': { us: '3.5', uk: '3', cm: '22' },
    '36':   { us: '4', uk: '3.5', cm: '22.5' },
    '36.5': { us: '4.5', uk: '4', cm: '23' },
    '37.5': { us: '5', uk: '4.5', cm: '23.5' },
    '38':   { us: '5.5', uk: '5', cm: '24' },
    '38.5': { us: '6', uk: '5.5', cm: '24.5' },
    '39':   { us: '6.5', uk: '6', cm: '25' },
    '40':   { us: '7', uk: '6.5', cm: '25.5' },
    '40.5': { us: '7.5', uk: '7', cm: '26' },
    '41':   { us: '8', uk: '7.5', cm: '26.5' },
    '42':   { us: '8.5', uk: '8', cm: '27' },
    '42.5': { us: '9', uk: '8.5', cm: '27.5' },
    '43':   { us: '9.5', uk: '9', cm: '28' },
    '44':   { us: '10', uk: '9.5', cm: '28.5' },
    '44.5': { us: '10.5', uk: '10', cm: '29' },
    '45':   { us: '11', uk: '10.5', cm: '29.5' },
    '45.5': { us: '11.5', uk: '11', cm: '30' },
    '46':   { us: '12', uk: '11.5', cm: '30.5' },
    '47':   { us: '12.5', uk: '12', cm: '31' },
    '47.5': { us: '13', uk: '12.5', cm: '31.5' },
    '48':   { us: '13.5', uk: '13', cm: '32' },
    '48.5': { us: '14', uk: '13.5', cm: '32.5' },
    '49.5': { us: '15', uk: '14.5', cm: '33.5' }
  };

  var customSizeMap = null;
  if (productData.size_chart) {
    try {
      var chart = typeof productData.size_chart === 'string'
        ? JSON.parse(productData.size_chart) : productData.size_chart;
      customSizeMap = {};
      chart.forEach(function (row) {
        customSizeMap[row.eu] = { us: row.us, uk: row.uk, cm: row.cm };
      });
    } catch (e) { customSizeMap = null; }
  }

  function getSizeConversion(euSize) {
    return (customSizeMap || SIZE_MAP)[euSize] || null;
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return moneyFormat.replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount);
  }

  // --- Find matching variant based on selected color + size ---
  function findVariant(color, size) {
    var sizePos = sizeOptionIndex ? sizeOptionIndex - 1 : 0;
    var colorPos = colorOptionIndex ? colorOptionIndex - 1 : null;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var optionKey = 'option' + (sizePos + 1);
      var sizeMatch = size ? v[optionKey] === size : true;

      var colorMatch = true;
      if (color && colorPos !== null) {
        var colorKey = 'option' + (colorPos + 1);
        colorMatch = v[colorKey] === color;
      }

      if (sizeMatch && colorMatch) return v;
    }
    return null;
  }

  // --- Update page when variant changes ---
  var priceEl = document.querySelector('[data-price]');
  var compareEl = document.querySelector('.sl-price__compare');
  var variantInput = document.getElementById('sl-variant-id');
  var addToCartBtn = document.getElementById('sl-add-to-cart');
  var stockDelivery = document.getElementById('sl-stock-delivery');

  var pickupToggle = document.getElementById('sl-pickup-toggle');
  var skuEl = document.getElementById('sl-sku');

  function updateVariant(variant) {
    if (!variant) return;

    // Update hidden input
    variantInput.value = variant.id;

    // Update SKU
    if (skuEl) skuEl.textContent = variant.sku || '';

    // Update price
    priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // Update add to cart button
    if (variant.available) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Ajouter au panier';
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Rupture de stock';
    }

    // Update pickup button — grise si pas en stock physique
    if (pickupToggle) {
      pickupToggle.disabled = variant.inventory_quantity <= 0;
    }

    // Update stock + delivery
    updateStockDelivery(variant);

    // Update URL
    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    history.replaceState(null, '', url.toString());
  }

  function updateStockDelivery(variant) {
    var qty = variant.inventory_quantity;
    var html = '';

    if (qty > 0) {
      // EN STOCK — 24/48h active, 5-12j grise
      html += '<div class="sl-stock sl-stock--in">';
      html += '<span class="sl-stock__text">Plus que <strong>' + qty + '</strong> produit' + (qty > 1 ? 's' : '') + ' en stock</span>';
      html += '</div>';
      html += '<div class="sl-delivery">';
      html += '<div class="sl-delivery__option sl-delivery__option--fast" data-tooltip="En stock, pret a etre expedie depuis notre entrepot et/ou nos boutiques. Jours ouvres uniquement.">';
      html += '<span class="sl-delivery__dot">&#9679;</span>';
      html += '<span>Livraison <strong>24/48h</strong></span>';
      html += '</div>';
      html += '<div class="sl-delivery__option sl-delivery__option--inactive" data-tooltip="Approvisionnement via notre reseau de revendeurs partenaires. Jours ouvres uniquement.">';
      html += '<span class="sl-delivery__dot">&#9675;</span>';
      html += '<span>Livraison 5 \u00e0 12 jours</span>';
      html += '</div>';
      html += '</div>';
    } else if (variant.available) {
      // SUR COMMANDE — 24/48h grise, 5-12j active
      html += '<div class="sl-stock sl-stock--order">';
      html += '<span class="sl-stock__text">Disponible sur commande</span>';
      html += '</div>';
      html += '<div class="sl-delivery">';
      html += '<div class="sl-delivery__option sl-delivery__option--inactive" data-tooltip="En stock, pret a etre expedie depuis notre entrepot et/ou nos boutiques. Jours ouvres uniquement.">';
      html += '<span class="sl-delivery__dot">&#9675;</span>';
      html += '<span>Livraison 24/48h</span>';
      html += '</div>';
      html += '<div class="sl-delivery__option sl-delivery__option--partner" data-tooltip="Approvisionnement via notre reseau de revendeurs partenaires. Jours ouvres uniquement.">';
      html += '<span class="sl-delivery__dot">&#9679;</span>';
      html += '<span>Livraison <strong>5 \u00e0 12 jours</strong></span>';
      html += '</div>';
      html += '</div>';
    } else {
      // RUPTURE TOTALE
      html += '<div class="sl-stock sl-stock--out">';
      html += '<span class="sl-stock__text">Rupture de stock</span>';
      html += '</div>';
    }

    stockDelivery.innerHTML = html;
  }

  // --- Update size buttons availability when color changes ---
  function updateSizeAvailability() {
    var sizePos = sizeOptionIndex ? sizeOptionIndex - 1 : 0;
    var colorPos = colorOptionIndex ? colorOptionIndex - 1 : null;
    var sizeBtns = document.querySelectorAll('.sl-sizes__btn');

    sizeBtns.forEach(function (btn) {
      var size = btn.dataset.size || btn.dataset.sizeEu;
      var variant = findVariant(selectedColor, size);

      if (variant) {
        btn.dataset.variantId = variant.id;
        btn.dataset.variantPrice = variant.price;
        btn.dataset.variantComparePrice = variant.compare_at_price;
        btn.dataset.variantAvailable = variant.available;
        btn.dataset.variantInventory = variant.inventory_quantity;

        // Update price display on button
        var priceLabel = btn.querySelector('.sl-sizes__btn-price');
        if (priceLabel) priceLabel.textContent = formatMoney(variant.price);

        if (variant.available) {
          btn.classList.remove('is-soldout');
          btn.disabled = false;
        } else {
          btn.classList.add('is-soldout');
          btn.disabled = true;
        }
      } else {
        btn.classList.add('is-soldout');
        btn.disabled = true;
      }
    });
  }

  // --- Color selector ---
  colorBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      colorBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      this.classList.add('is-selected');
      selectedColor = this.dataset.color;

      // Update color name
      var colorName = document.getElementById('sl-color-name');
      if (colorName) colorName.textContent = selectedColor;

      // Update size availability for this color
      updateSizeAvailability();

      // If a size is selected, find the matching variant
      if (selectedSize) {
        var variant = findVariant(selectedColor, selectedSize);
        if (variant) updateVariant(variant);
      }
    });
  });

  // --- Size selector ---
  var sizeButtons = document.querySelectorAll('.sl-sizes__btn');
  sizeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var size = this.dataset.size || this.dataset.sizeEu;
      if (!size) return;

      var variant = findVariant(selectedColor, size);
      if (!variant || !variant.available) return;

      selectedSize = size;

      sizeButtons.forEach(function (b) { b.classList.remove('is-selected'); });
      this.classList.add('is-selected');

      updateVariant(variant);
    });
  });

  // --- Size system tabs (EU/US/UK/CM) ---
  var sizeTabs = document.querySelectorAll('.sl-sizes__tab');
  sizeTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      sizeTabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('is-active');
      this.setAttribute('aria-selected', 'true');
      updateSizeLabels(this.dataset.sizeSystem);
    });
  });

  function updateSizeLabels(system) {
    sizeButtons.forEach(function (btn) {
      var euSize = btn.dataset.sizeEu;
      var label = btn.querySelector('[data-size-label]');
      if (!label) return;

      if (system === 'eu') {
        label.textContent = euSize;
      } else {
        var conv = getSizeConversion(euSize);
        label.textContent = (conv && conv[system]) ? conv[system] : euSize;
      }
    });
  }

  // --- Gallery ---
  var slides = document.querySelectorAll('.sl-gallery__slide');
  var thumbs = document.querySelectorAll('.sl-gallery__thumb');
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  var currentSlide = 0;

  function showSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentSlide = index;
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    if (slides[currentSlide]) slides[currentSlide].classList.add('is-active');
    if (thumbs[currentSlide]) thumbs[currentSlide].classList.add('is-active');
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(currentSlide - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(currentSlide + 1); });
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showSlide(parseInt(this.dataset.thumbIndex, 10));
    });
  });

  // Swipe mobile
  var gallery = document.querySelector('.sl-gallery__main');
  if (gallery) {
    var touchStartX = 0;
    gallery.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) showSlide(diff > 0 ? currentSlide + 1 : currentSlide - 1);
    }, { passive: true });
  }

  // --- Size guide modal ---
  var modal = document.getElementById('size-guide-modal');
  document.querySelectorAll('[data-open-size-guide]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (modal) modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  if (modal) {
    modal.querySelectorAll('[data-close-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // --- Click & Collect toggle ---
  var pickupToggle = document.getElementById('sl-pickup-toggle');
  var pickupList = document.getElementById('sl-pickup-list');
  if (pickupToggle && pickupList) {
    pickupToggle.addEventListener('click', function () {
      pickupList.style.display = pickupList.style.display === 'none' ? 'block' : 'none';
    });
  }

})();
